import type { AiImageAnnotation } from "@productlane/lib/src/ai"
import { annotationSvg } from "@productlane/lib/src/ai"
import { cn } from "@productlane/lib/src/cn"

// Thin adapter over the shared SVG drawing, so the live overlay and the
// server-baked raster come from the same string.
export const AnnotationOverlay = ({
	annotations,
	width,
	height,
	className,
}: {
	annotations: AiImageAnnotation[]
	width: number
	height: number
	className?: string
}) => {
	if (annotations.length === 0) return null

	return (
		<div
			className={cn("pointer-events-none absolute inset-0", className)}
			aria-hidden="true"
			dangerouslySetInnerHTML={{
				__html: annotationSvg(
					{ width, height, annotations },
					{ className: "h-full w-full" },
				),
			}}
		/>
	)
}
